module.exports = __webpack_public_path__ + "static/IMG-4-dd7df3c572d727ee5529b2d6e34e3bcf.jpg";